import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

import {
  setActiveOverlayGivenOffsetFromActive
} from 'current';
import {
  getActiveOverlayDate,
  getActiveOverlayTitle,
  getOverlayUuidGivenOffsetFromActive,
  isOverlayActive,
  isOverlayQuickSelectActive
} from 'current/selectors';
import {
  setIsOverlayActive,
  setIsOverlayQuickSelectActive
} from 'current/uiwidgets';

// requesters
import { requestEditImageryLayers } from 'imagery/requesters';

import OverlaySelectTrigger from 'triggers/OverlaySelectTrigger';
import OverlayQuickDateSelect from 'mapping/OverlayQuickDateSelect';


class OverlaySelectContainer extends Component {

  componentDidMount() {
    this.props.onMount();
  }

  render() {
    const {
      hasNextDate,
      hasPreviousDate,
      isActive,
      isQuickSelectActive,
      onSelectNext,
      onSelectPrevious,
      onToggleShowOverlay,
      onToggleShowOverlayQuickSelect,
      overlayTitle,
      selectedDate
    } = this.props;

    return (
      <div>
        <OverlaySelectTrigger
          isActive={isActive}
          isQuickSelectActive={isQuickSelectActive}
          onToggleShowOverlay={onToggleShowOverlay}
          onToggleShowOverlayQuickSelect={onToggleShowOverlayQuickSelect}
          overlayTitle={overlayTitle}
        />
        <OverlayQuickDateSelect
          hasNextDate={ hasNextDate }
          hasPreviousDate={ hasPreviousDate }
          onSelectNext={ onSelectNext }
          onSelectPrevious={ onSelectPrevious }
          selectedDate={selectedDate}
        />
      </div>
    );
  }
}

OverlaySelectContainer.propTypes = {
  hasNextDate: propTypes.bool.isRequired,
  hasPreviousDate: propTypes.bool.isRequired,
  isActive: propTypes.bool.isRequired,
  isQuickSelectActive: propTypes.bool.isRequired,
  onMount: propTypes.func.isRequired,
  onSelectNext: propTypes.func,
  onSelectPrevious: propTypes.func,
  onToggleShowOverlay: propTypes.func.isRequired,
  onToggleShowOverlayQuickSelect: propTypes.func.isRequired,
  overlayTitle: propTypes.string,
  selectedDate: propTypes.string
};

OverlaySelectContainer = connect(
  (state) => {
    return {
      hasNextDate: !!getOverlayUuidGivenOffsetFromActive(state, -1),
      hasPreviousDate: !!getOverlayUuidGivenOffsetFromActive(state, 1),
      isActive: isOverlayActive(state),
      isQuickSelectActive: isOverlayQuickSelectActive(state),
      overlayTitle: getActiveOverlayTitle(state),
      selectedDate: getActiveOverlayDate(state)
    };
  },
  (dispatch) => {
    return {
      onMount: () => dispatch(requestEditImageryLayers()),
      onSelectPrevious: () => dispatch(setActiveOverlayGivenOffsetFromActive(1)),
      onSelectNext: () => dispatch(setActiveOverlayGivenOffsetFromActive(-1)),
      onToggleShowOverlay: (setTo) => {
        dispatch(setIsOverlayActive(setTo));
      },
      onToggleShowOverlayQuickSelect: (setTo) => { dispatch(setIsOverlayQuickSelectActive(setTo)); }
    };
  }
)(OverlaySelectContainer);

export default OverlaySelectContainer;
